export const loblawPalette = {
    text:{ secondary:'#6e6e6e'}
}